module.exports = __webpack_public_path__ + "static/media/sa.e5a120b5.svg";